import { Hero } from "@/components/Hero";
import { SocialProof } from "@/components/SocialProof";
import { CtaBand } from "@/components/CtaBand";
import { DomainStory } from "@/components/DomainStory";
import { Section, SectionHeading, Stat } from "@/components/kit";
import { Card } from "@/components/Card";
import { HOW_IT_WORKS, DOMAIN_STORIES, STATS } from "@/content/home";
import { PROOF_POINTS } from "@/content/proof";

export default function Home() {
  return (
    <>
      {/* 1. Hero */}
      <Hero />

      {/* 2. Proof strip */}
      <SocialProof points={PROOF_POINTS} />

      {/* 3. How it works */}
      <Section wash="wash">
        <SectionHeading
          eyebrow="How it works"
          title="Intent in. Build-ready, physics-verified device out."
          intro="Three stages, one continuous model — nothing gets re-entered, re-drawn or re-verified moving between them."
        />
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {HOW_IT_WORKS.map((s) => (
            <Card key={s.num} className="flex flex-col gap-3">
              <span className="font-mono text-sm font-bold text-primary">{s.num}</span>
              <h3 className="text-lg font-extrabold tracking-tight text-foreground">{s.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{s.body}</p>
            </Card>
          ))}
        </div>
      </Section>

      {/* 4. Domain story band — the same loop, three beats */}
      <Section wash="surface">
        <SectionHeading
          eyebrow="One loop, real physics"
          title="From canvas to closed-loop physics."
          intro="A system you wire on the canvas runs against real rigid-body dynamics on the GPU — same signals, same twin, validated end to end."
        />
        <div className="mt-16 flex flex-col gap-16">
          {DOMAIN_STORIES.map((story, i) => (
            <DomainStory key={story.domain} story={story} flip={i % 2 === 1} />
          ))}
        </div>
      </Section>

      {/* 5. Stat strip */}
      <Section bordered>
        <div className="grid grid-cols-2 gap-y-10 sm:grid-cols-4">
          {STATS.map((s) => (
            <Stat key={s.label} value={s.value} label={s.label} />
          ))}
        </div>
      </Section>

      {/* 6. Closing CTA band */}
      <CtaBand />
    </>
  );
}
